import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e42ad27a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-fire" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "my-fire__item-title" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "my-fire__item-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "报警部件：", -1))
const _hoisted_7 = { style: {"color":"#FF5B34"} }
const _hoisted_8 = { class: "my-fire__item-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "部件编码：", -1))
const _hoisted_10 = { class: "van-multi-ellipsis--l2" }
const _hoisted_11 = { class: "my-fire__item-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "位置：", -1))
const _hoisted_13 = { class: "van-multi-ellipsis--l2" }
const _hoisted_14 = { class: "my-fire__item-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "时间：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.state.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.state.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.loading) = $event)),
          finished: _ctx.state.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "my-fire__item",
                key: item.id,
                onClick: ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.FIRE_DETAIL,
              params: {
                id: item.id
              }
            })
          )
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.fire_type_id_name), 1),
                  (item.fire_parts_lists?.length > 1)
                    ? (_openBlock(), _createBlock(_component_van_icon, {
                        key: 0,
                        name: "orders-o"
                      }))
                    : _createCommentVNode("", true),
                  (item.is_overtime == '1')
                    ? (_openBlock(), _createBlock(_component_van_tag, {
                        key: 1,
                        plain: "",
                        color: "rgb(255, 91, 52)",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("超时")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_button, {
                    class: "state",
                    color: _ctx.colors[item.fire_state] || '#7232dd',
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.fire_state_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, [
                    (item.fire_parts_lists?.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(item.fire_parts_lists[0].name) + " " + _toDisplayString(item.fire_parts_lists.length > 1 ? "等" : ""), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 无 ")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, [
                    (item.fire_parts_lists?.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(item.fire_parts_lists[0].code) + " " + _toDisplayString(item.fire_parts_lists.length > 1 ? `等${item.fire_parts_lists.length}个` : ""), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 无 ")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, [
                    (item.fire_parts_lists?.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(item.fire_parts_lists[0].true_place_name) + " " + _toDisplayString(item.fire_parts_lists.length > 1 ? `等` : ""), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 无 ")
                        ], 64))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(item.fire_time_name), 1)
                ])
              ], 8, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}